module.exports = __webpack_public_path__ + "img/7_127.636a2d02.png";